import { Select as MantineSelect, type SelectProps } from "@mantine/core";
import { useCallback } from "react";
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form";

interface Props<T extends FieldValues> extends SelectProps {
  name: Path<T>;
  control: Control<T>;
  onChange?: (value: string) => void | Promise<void>;
  required?: boolean;
}

function Select<T extends FieldValues>({
  name,
  control,
  onChange,
  required,
  ...props
}: Props<T>) {
  const {
    field: { onChange: defaultOnChange, ...field },
    fieldState: { invalid },
  } = useController({
    name,
    control,
    rules: { required },
  });

  const handleChange = useCallback(
    async (value: string) => {
      defaultOnChange(value);
      if (onChange) await onChange(value);
    },
    [defaultOnChange, onChange],
  );

  return (
    <MantineSelect
      {...field}
      value={field.value ?? null}
      {...props}
      onChange={handleChange}
      error={invalid}
    />
  );
}

export default Select;
